export const allThemeNames = [
    "atomidata",
    "cognovum",
    "daruur",
    "denvr",
    "dataxion",
    "dimensicloud",
    "hostnic",
    "hostsailor",
    "hostzop",
    "idcloudhost",
    "kolodc",
    "metal",
    "nforce",
    "pilvio",
    "rackdog",
    "rackzar",
    "readyidc",
    "serverwala",
    "stacklogic",
    "tenbyte",
    "vdc",
    "warren",
    "web1",
    "hpe",
    "telia",
    "elisa",
    "eslcloud",
] as const;

export type ThemeName = (typeof allThemeNames)[number];
